export const MODAL_ID_PREFIX = "alma-in-page-modal";

export const URLS = {
  embedded: "/in-page/embedded/",
  modal: "/in-page/modal/",
};
